import {AuthService} from '../services';
import {bindLoading} from './index';
import router from '../routes';
import {IdentityTypes} from "@/constants";
export default {
    namespaced: true,
    state: {
        showFailureMessage: false,
        name: '',
        email: '',
        claims: [],
        userId: '',
        identityType: IdentityTypes.None
    },
    getters: {
        authenticated(state) {
            return state.claims.length > 0;
        },
        token(){
            return AuthService.getAuthToken();
        },
        isBookable(state){
            return state.claims.some(c => c === 'user' || c === 'admin' || c === 'super');
        }
    },
    mutations: {
        logout(state) {
            AuthService.logout();
            state.name = '';
            state.email = '';
            state.claims.splice(0);
            state.userId = '';
            state.identityType = IdentityTypes.None;
            state.showFailureMessage = false;
            // window.location = '/';
            router.replace('/login');
        },

        saveAuthInfo(state, {userId, claims, name, email, identityType}) {
            state.showFailureMessage = claims.length <= 0;
            state.userId = userId;
            state.name = name;
            state.email = email;
            state.identityType = identityType;
            state.claims.splice(0);
            state.claims.push(...claims);
        },

        reloadAuth(state) {
            const {claims, name, email, userId, identityType} = AuthService.getAuth();
            state.showFailureMessage = false;
            state.userId = userId;
            state.name = name;
            state.email = email;
            state.identityType = identityType;
            state.claims.splice(0);
            state.claims.push(...claims);
        }
    },
    actions: {
        async authenticate({commit}, cred) {
            const result = await bindLoading(commit, async () => {
                const authInfo = await AuthService.login(cred);
                commit({
                    type: 'saveAuthInfo',
                    ...authInfo
                });
                return authInfo;
            }, 'auth');
            return result.claims.length > 0;
        }
    }
}